const validate = require('@weo-edu/validate')
const Schema = require('@weo-edu/schema')

const getDistrictsAndSchools = Schema()

exports.getDistrictsAndSchools = validate(getDistrictsAndSchools)
